/**
 * Utility functions for trimming keys and values in objects before sending to backend
 */

/**
 * Recursively trims string values and keys in an object
 * @param obj - The object to trim
 * @returns A new object with trimmed keys and values
 */
export function trimObjectKeysAndValues<T = any>(obj: any): T {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (typeof obj === 'string') {
    return obj.trim() as T;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => trimObjectKeysAndValues(item)) as T;
  }

  if (typeof obj === 'object') {
    const trimmedObj: any = {};

    for (const [key, value] of Object.entries(obj)) {
      const trimmedKey = typeof key === 'string' ? key.trim() : key;
      const trimmedValue = trimObjectKeysAndValues(value);

      // Only add the property if the trimmed key is not empty
      if (trimmedKey !== '') {
        trimmedObj[trimmedKey] = trimmedValue;
      }
    }

    return trimmedObj as T;
  }

  return obj;
}

/**
 * Trims form data specifically for campaign creation/update
 * @param formData - The form data to trim
 * @returns Trimmed form data
 */
export function trimCampaignFormData(formData: any) {
  return trimObjectKeysAndValues(formData);
}

/**
 * Trims form data specifically for phone number mapping creation/update
 * @param formData - The form data to trim
 * @returns Trimmed form data
 */
export function trimCommunicationIntegrationFormData(formData: any) {
  return trimObjectKeysAndValues(formData);
}